import { environment } from "src/environments/environment";

export const VS_PEER_TAB = {
  label: "Vs Peers",
  id: "peer",
  index: 0,
  mapping: "valuationpeertab",
};
export const COMPANY_TAB = {
  label: "Company",
  id: "company",
  index: 1,
  mapping: "valuationcompanytab",
};
export const CHARTS_TAB = {
  label: "Charts",
  id: "chart",
  index: 2,
  mapping: "valuationcharttab",
};

export const CY_PERIOD_BASIS = {
  id: "cal",
  label: "Calendar",
  prefix: "CY",
  relativePrefix: "C",
};

export const FY_PERIOD_BASIS = {
  id: "fy",
  label: "Fiscal",
  prefix: "FY",
  relativePrefix: "F",
};

export const ABS_PERIOD_TYPE = {
  id: "abs",
  label: "Absolute",
  dataId: "absolute",
};

export const REL_PERIOD_TYPE = {
  id: "rel",
  label: "Relative",
  dataId: "relative",
};

export const NTM_STM_BLENDED = "blended";
export const NTM_STM_UNREPORTED = "unreported_qtrs";
export const CALENDARIZATION_WEIGHTED = "weighted";
export const CALENDARIZATION_DAILY = "daily";

export const NTM_STM_OPTIONS = [
  {
    id: NTM_STM_BLENDED,
    label: "Rolling 365 Days",
    info: {
      description:
        "“Rolling 365 Days” calculates the value for the Next Twelve Months (NTM, starting tomorrow) or the Second Twelve Months (STM, starting a year from tomorrow) as a daily, time-weighted interpolation of the relevant current or upcoming fiscal periods, reported or not. Whether Interim or Annual estimates are used in the interpolation is based on the Calendarization Method you have selected. Our support site further illustrates this with examples ",
      link:
        environment.SUPPORT_LINKS.base_link +
        environment.SUPPORT_LINKS.en_US +
        environment.SUPPORT_LINKS.articles.calendarization_methods,
    },
  },
  {
    id: NTM_STM_UNREPORTED,
    label: "Unreported Periods (Interims Only)",
    info: {
      description:
        "“Unreported Periods (Interims Only)” calculates the Next Twelve Months (NTM) or the Second Twelve Months (STM) as the sum of either the next four unreported quarters (or the following four for STM), or the next two unreported semi-annual periods (or the following two for STM). Note that NTM includes the current interim period which may have already concluded if the company has yet to report its results. The Calendarization Method you have selected is ignored and only quarterly or semi-annual periods are used in this calculation. No result is provided if only Annual forecasts for the company are available. Our support site further illustrates this with examples ",
      link:
        environment.SUPPORT_LINKS.base_link +
        environment.SUPPORT_LINKS.en_US +
        environment.SUPPORT_LINKS.articles.calendarization_methods,
    },
  },
];

export const CALENDARIZATION_OPTIONS = [
  {
    id: CALENDARIZATION_DAILY,
    label: "Annual Interpolation",
  },
  {
    id: CALENDARIZATION_WEIGHTED,
    label: "Adjusted Interims (as available)",
  },
];

export const CURRENT_YEAR = new Date().getFullYear();
export const ACTUAL_CALENDAR_YEAR = CURRENT_YEAR - 1;
export const REL_BASE_YEAR = 0;
export const REL_MIN_YEAR_RANGE = -30;
export const REL_MAX_YEAR_RANGE = 30;
export const ABS_MIN_YEAR_RANGE = ACTUAL_CALENDAR_YEAR + REL_MIN_YEAR_RANGE;
export const ABS_MAX_YEAR_RANGE = ACTUAL_CALENDAR_YEAR + REL_MAX_YEAR_RANGE;
export const DEFAULT_FROM_YEAR = ACTUAL_CALENDAR_YEAR;
export const DEFAULT_TO_YEAR = ACTUAL_CALENDAR_YEAR + 2;

export const VALUATION_LOG_ACTION_FEATURES = {
  pageVisit: "VALUATION_PAGE_VISIT",
  addTicker: "VALUATION_ADD_TICKER",
  removeTicker: "VALUATION_REMOVE_TICKER",
  visitPage: "VALUATION_VISIT_PAGE",
  tabSwitch: "VALUATION_TAB_SWITCH",
  updateRatio: "VALUATION_UPDATE_RATIO",
  updatePeriod: "VALUATION_UPDATE_PERIOD",
  updateCurrency: "VALUATION_UPDATE_CURRENCY",
  updateRevision: "VALUATION_UPDATE_REVISION",
  updateScaleType: "VALUATION_UPDATE_SCALETYPE",
  updateViewOrientation: "VALUATION_UPDATE_VIEW_ORIENTATION",
  updatePeriodCalculation: "VALUATION_UPDATE_PERIOD_CALCULATION_SETTINGS",
  dataCall: "VALUATION_DATA",
  export: "VALUATION_EXCEL_EXPORT",
};

export const VALUATION_PAGE = "VALUATION_PAGE";

export const CHART_LEGEND_COLORS = [
  "#304da5",
  "#0f4040",
  "#a53088",
  "#d1d100",
  "#412504",
  "#6c30a5",
  "#073c5f",
  "#034c1a",
  "#871000",
  "#e88e82",

  "#9cade2",
  "#36abad",
  "#d275bb",
  "#e1e143",
  "#a87230",
  "#a575d2",
  "#1874ae",
  "#15813e",
  "#a61b08",
  "#f3bfb7",

  "#e6ebfc",
  "#82e5e6",
  "#f6d6ee",
  "#f4f4b1",
  "#eed7bb",
  "#e7d6f6",
  "#8bc3e3",
  "#66cd8f",
  "#c23824",
  "#fae1de",
];

export const CHART_LEGEND_SHAPES = ["circle"];

export const SCALE_TYPE_LIST = [
  { key: "Absolute", value: "Absolute" },
  { key: "Index to 100", value: "Index" },
];
